export default function () {

	$('.button-play').on('click', function(){
		var video_id = $(this).data('video');
		$('.video_lightbox iframe').attr('src', "https://www.youtube.com/embed/" + video_id + "?enablejsapi=1&rel=0")
		$('.video_lightbox').addClass('active');
	});
}